import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';

import App from './App.vue';
import { router } from './router';
import { i18n } from './locales';
import './styles/main.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        // Availability changes constantly as other people book, so it is never
        // considered fresh for long and is re-checked whenever the tab regains
        // focus. Individual queries tighten this further.
        staleTime: 15_000,
        refetchOnWindowFocus: true,
        retry: 1,
      },
    },
  },
});

app.mount('#app');
